import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, Directive, HostListener, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../services/customer.service';
import { GlobalsService } from '../../services/globals.service';
import { OrdersService } from '../../services/orders.service';
import { InventoryService } from '../../services/inventory.service';
import { Location, DatePipe } from '@angular/common'
import { Subject, Observable, forkJoin, of } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { valHooks } from 'jquery';
import * as XLSX from 'xlsx';

@Component({
	selector: 'app-system-types-view',
	templateUrl: './system-types-view.component.html',
	styleUrls: ['./system-types-view.component.scss'],
	providers: [DatePipe]
})

export class SystemTypesViewComponent implements OnInit {

	@ViewChild('addCustomer') addcustomeref: ElementRef;
	@ViewChild('editExclusions') ruleRef: ElementRef;
	@ViewChild('addVendor') addvendorref: ElementRef;
	@ViewChild('addSalesTypeEle') addsalestyperef: ElementRef;
	@ViewChild('addPaymentTermEle') addPaymentTermref: ElementRef;
	@ViewChild('addClubEle') addclubref: ElementRef;
	@ViewChild('addContactTypeEle') addcontacttyperef: ElementRef;
	@ViewChild('addProductType') addproducttyperef: ElementRef;
	@ViewChild('paymentTermsHelp') paymentTermsHelpRef: ElementRef;

	isSaving: any = false;
	isLoading = false;
	salestypes: any = [];
	supptypes: any = [];
	customertypes: any = [];
	payment_terms: any = [];
	all_types: any = [];
	color: any = 'blue'
	customerTypeForm: UntypedFormGroup;
	paymentTermsForm: UntypedFormGroup;
	vendorTypeForm: UntypedFormGroup;
	salesTypeForm: UntypedFormGroup;
	exclusionForm: UntypedFormGroup;

	contacttypes: any = [];
	contactTypeForm: UntypedFormGroup;
	productTypeForm: UntypedFormGroup;
	productTypes: any[] = [];
	productTypesLoading = false;
	productTypeSaving = false;


	clubForm: UntypedFormGroup;
	uploaddata: any = false;
	files: any = [];
	tablename: any = false;
	mapcols: any = [
		{ field: 'stockid', label: 'Stock ID' },
		{ field: 'brand',   label: 'Brand' },
		{ field: 'partno',  label: 'Part No.' },
		{ field: 'price',   label: 'Price' },
		{ field: 'ignore',  label: '— ignore —' },
	];
	editrule_type: any = 'P';
	editrule_name: any = '';
	currentrule: any = [];
	currenttype: any = '';
	ruleset: any = [];
	ruletypes: any = {
		'B': 'Brand',
		'P': 'Product Line',
		'C': 'Item Category',
		'S': 'Specific Item'
	};
	custtypes: any = [];
	prodlines: any = [];
	categories: any = [];
	brands: any = [];
	clubs: any = [];
	mapping: any = {};
	matchedItems: any[] = [];
	unmatchedItems: any[] = [];
	readonly pricebookBatchLimitDefault = 250;
	readonly pricebookBatchLimitMin = 1;
	readonly pricebookBatchLimitMax = 2000;
	pricebookBatchLimit: number | string = this.pricebookBatchLimitDefault;

	isSearching = false;
	currentBatch = 0;
	totalBatches = 0;
	totalProcessed = 0;
	mappedCount = 0;
	unmappedCount = 0;
	isPostingBatches = false;
	postingCurrentBatch = 0;
	postingTotalBatches = 0;
	postingProcessed = 0;
	postingSucceeded = 0;
	postingFailed = 0;
	trandate: any = '';
	duedate: any = '';
	exampleTranDate = new UntypedFormControl(new Date());
	calculatingDue: any = false;

	protectedRoles = ['INVOICE', 'STATEMENT', 'MARKETING'];
	isProtectedContact = false;
	isEditingPaymentTerm = false;

	paymentTermsSearchFilter = '';

	/** Shown after Save on sales type modal; modal stays open until user dismisses or closes. */
	salesTypeSaveResult: { ok: boolean; title: string; lines: string[] } | null = null;

	/** After Final Post Matched: concrete counts from the server (per batch aggregated). */
	pricebookPostSummaryLines: string[] | null = null;

	/** Bumped when the user clears the upload or picks a new file so in-flight parses do not repopulate the UI. */
	private pricebookParseNonce = 0;

	/** Row count for determinate progress while Find Missing Stock IDs runs. */
	pricebookLookupTotalRows = 0;
	/** Row count for determinate progress while Final post runs. */
	pricebookPostingTotalRows = 0;
	/** Rows that received a stock ID in the most recent Find Missing Stock IDs run (see template + SCSS). */
	pricebookLastLookupNewMatchCount = 0;

	/** UI-only pagination for parsed sheet preview (full arrays still used for lookup/post). */
	readonly pricebookViewPageSizeOptions = [25, 50, 100, 250];
	pricebookMapPageIndex = 0;
	pricebookMapPageSize = 50;
	pricebookMatchedPageIndex = 0;
	pricebookMatchedPageSize = 50;
	pricebookUnmatchedPageIndex = 0;
	pricebookUnmatchedPageSize = 50;

	pricebookScratchTablename: string | null = null;
	pricebookUploadHeaderMeta: Array<{ original: string; column: string }> = [];
	pricebookStagingRowsTotal = 0;
	pricebookMatchedStagingTotal = 0;
	pricebookUnmappedStagingTotal = 0;
	private pricebookApplyMappingTimer: ReturnType<typeof setTimeout> | null = null;

	pricebookResumeOffer: {
		tablename: string;
		rowCount: number;
		matchedCount: number;
		postedCount: number;
		sourceFilename: string;
	} | null = null;

	constructor(private ordersService: OrdersService, private inventoryService: InventoryService, private customerService: CustomerService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private route: ActivatedRoute, private location: Location, public router: Router, private globalSearchService: GlobalSearchService, private modalService: NgbModal, private datePipe: DatePipe, private cdr: ChangeDetectorRef) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {

		this.productTypeForm = this.fb.group({
			label: ['', [Validators.required, Validators.maxLength(1), Validators.minLength(1)]],
			original_label: [''],
			description: ['', Validators.maxLength(24)],
			createmovements: [true],
			isdefault: [false],
			haschildren: [false],
			requiresconfig: [false],
			requirespick: [true],
			reducesstock: [true],
		});
		this.loadProductTypes();

		this.globalSearchService.all_system_types.subscribe((alltypes: any) => {

			this.customerTypeForm = this.fb.group({
				typeid: [''],
				typename: ['', Validators.required],
				address_type: ['2', Validators.required] // Default to '2' (Visible POS)
			});

			this.vendorTypeForm = this.fb.group({
				typeid: [''],
				typename: ['', Validators.required],
			});

			this.salesTypeForm = this.fb.group({
				typeabbrev: ['', Validators.required],
				sales_type: ['', Validators.required],
				costMultiplier: ['1', Validators.required],
				loyaltypoints: ['0', Validators.required],
				fallback: [''],
				tablename: [''],
				newpricebook: [false],
				ispricebook: ['0']
			});

			this.contactTypeForm = this.fb.group({
				contact_type: ['', Validators.required],
				contact_role: ['', Validators.required],
			});


			if (alltypes) {
				this.supptypes = alltypes.supptypes;
				this.customertypes = alltypes.debtortypes;
				this.salestypes = alltypes.salestypes;
				this.contacttypes = alltypes.contacttypes;

			}
			this.inventoryService.getItemCategories().subscribe((res) => {
				Object(res).sort((a, b) => (a.categorydescription > b.categorydescription) ? 1 : ((b.categorydescription > a.categorydescription) ? -1 : 0))
				this.categories = res;
			});
			this.inventoryService.getItemProductlines().subscribe(p => {
				this.prodlines = p
			});
			this.inventoryService.getBrands().subscribe((results: any) => {
				this.brands = results;
				this.customerService.getClubs().subscribe(details => {
					this.clubs = details;
				});
			})

		});

		this.globalSearchService.terms.subscribe((terms: any) => {
			this.payment_terms = terms;

			this.paymentTermsForm = this.fb.group({
				template: ['custom'],
				termsindicator: ['', Validators.required],
				terms: ['', Validators.required],
				statementperiods: ['0', Validators.required],
				daysbeforedue: ['0', Validators.required],
				dayinfollowingmonth: ['1', Validators.required],
				terms_discount: ['0.00', [Validators.required, Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
				numpayments: ['1', [Validators.required, Validators.min(1)]],
				cc_process: ['0', Validators.required],
				decline: ['0', Validators.required],
				collect_payment: ['0', Validators.required],
				donot_print: ['0', Validators.required],
				onaccountallowed: ['0', Validators.required],
				order_entry: ['1', Validators.required],
				agefrom: ['1'],
				ageto: [null],

			});
			this.startDueDateListeners();
			this.exampleTranDate.setValue(new Date());

		});

		void this.checkPricebookStagingResume();
	}

	startDueDateListeners() {
		this.paymentTermsForm.get('daysbeforedue').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.paymentTermsForm.get('dayinfollowingmonth').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.paymentTermsForm.get('statementperiods').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.paymentTermsForm.get('agefrom').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.paymentTermsForm.get('ageto').valueChanges.subscribe((newV) => {
			this.getExampleDueDate();
		})
		this.exampleTranDate.valueChanges.subscribe((newV) => {
			if (newV) {
				this.getExampleDueDate();
			}
		})
	}

	onDueDateTypeChange() {
		const type = this.paymentTermsForm.get('dueDateType').value;

		if (type === 'days') {
			// Set days, clear day of month
			this.paymentTermsForm.patchValue({
				dayinfollowingmonth: '0',
				statementperiods: '0'
			}, { emitEvent: false });
		} else if (type === 'dayOfMonth') {
			// Set day of month, clear days
			this.paymentTermsForm.patchValue({
				daysbeforedue: '0',
				statementperiods: '0'
			}, { emitEvent: false });
			// Set default day if not set
			if (!this.paymentTermsForm.get('dayinfollowingmonth').value ||
				this.paymentTermsForm.get('dayinfollowingmonth').value === '0') {
				this.paymentTermsForm.patchValue({
					dayinfollowingmonth: '10'
				}, { emitEvent: false });
			}
		} else if (type === 'endOfMonth') {
			// Set to end of month (31)
			this.paymentTermsForm.patchValue({
				daysbeforedue: '0',
				dayinfollowingmonth: '31',
				statementperiods: '0'
			}, { emitEvent: false });
		}

		// Trigger due date calculation if preview is open
		if (this.exampleTranDate.value) {
			this.getExampleDueDate();
		}
	}


	getExampleDueDate() {
		const trandateValue = this.exampleTranDate.value;
		let formattedDate: string;

		if (trandateValue instanceof Date) {
			const year = trandateValue.getFullYear();
			const month = String(trandateValue.getMonth() + 1).padStart(2, '0');
			const day = String(trandateValue.getDate()).padStart(2, '0');
			formattedDate = `${year}-${month}-${day}`;
		} else if (trandateValue) {
			formattedDate = trandateValue;
		} else {
			const today = new Date();
			const year = today.getFullYear();
			const month = String(today.getMonth() + 1).padStart(2, '0');
			const day = String(today.getDate()).padStart(2, '0');
			formattedDate = `${year}-${month}-${day}`;
		}

		const agefromValue = this.paymentTermsForm.get('agefrom').value;
		const agetoValue = this.paymentTermsForm.get('ageto').value;

		const data = {
			'daysbeforedue': parseInt(this.paymentTermsForm.get('daysbeforedue').value) || 0,
			'dayinfollowingmonth': parseInt(this.paymentTermsForm.get('dayinfollowingmonth').value) || 0,
			'trandate': formattedDate,
			'statementperiods': parseInt(this.paymentTermsForm.get('statementperiods').value) || 0,
			'agefrom': agefromValue && agefromValue !== null && agefromValue !== '' ? parseInt(agefromValue) : 1,
			'ageto': agetoValue && agetoValue !== null && agetoValue !== '' ? parseInt(agetoValue) : 25
		}

		this.calculatingDue = true;
		this.ordersService.exampleDueDate(data).subscribe((res) => {
			if (res.duedate) {
				let dueDateObj: Date;
				if (typeof res.duedate === 'string') {
					if (res.duedate.includes('/')) {
						const parts = res.duedate.split('/');
						dueDateObj = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
					} else if (res.duedate.includes('-')) {
						dueDateObj = new Date(res.duedate);
					} else {
						dueDateObj = new Date(res.duedate);
					}
				} else {
					dueDateObj = new Date(res.duedate);
				}
				if (!isNaN(dueDateObj.getTime())) {
					this.duedate = this.datePipe.transform(dueDateObj, 'MM/dd/yyyy') || res.duedate;
				} else {
					this.duedate = res.duedate;
				}
			} else {
				this.duedate = res.duedate;
			}

			if (res.trandate) {
				let tranDateObj: Date;
				if (typeof res.trandate === 'string') {
					if (res.trandate.includes('/')) {
						const parts = res.trandate.split('/');
						tranDateObj = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
					} else if (res.trandate.includes('-')) {
						tranDateObj = new Date(res.trandate);
					} else {
						tranDateObj = new Date(res.trandate);
					}
				} else {
					tranDateObj = new Date(res.trandate);
				}
				if (!isNaN(tranDateObj.getTime())) {
					this.trandate = this.datePipe.transform(tranDateObj, 'MM/dd/yyyy') || res.trandate;
				} else {
					this.trandate = res.trandate;
				}
			} else {
				this.trandate = res.trandate;
			}

			this.calculatingDue = false;

		}, (error) => {
			this.calculatingDue = false;
			console.error('Error calculating due date:', error);
		})
	}


	yesNoValue(input: any) {
		return (input == '1') ? 'Y' : 'N';
	}





	getFilteredPaymentTerms() {
		let filtered = this.payment_terms || [];

		if (this.paymentTermsSearchFilter) {
			const searchLower = this.paymentTermsSearchFilter.toLowerCase();
			filtered = filtered.filter(term =>
				(term.termsindicator && term.termsindicator.toLowerCase().includes(searchLower)) ||
				(term.terms && term.terms.toLowerCase().includes(searchLower))
			);
		}

		// Type filter removed - no longer using template system

		return filtered;
	}

	getPaymentTermDescription(term: any): string {
		if (!term) {return '';}

		const daysbeforedue = parseInt(term.daysbeforedue) || 0;
		const dayinfollowingmonth = parseInt(term.dayinfollowingmonth) || 0;
		const statementperiods = parseInt(term.statementperiods) || 0;
		const terms_discount = parseFloat(term.terms_discount) || 0;

		const parts: string[] = [];

		if (daysbeforedue > 0 && dayinfollowingmonth === 0) {
			parts.push(`Net ${daysbeforedue}`);
		} else if (dayinfollowingmonth > 0) {
			if (dayinfollowingmonth === 31) {
				parts.push('End of month');
			} else {
				parts.push(`Day ${dayinfollowingmonth} of month`);
			}
		}

		if (statementperiods > 0) {
			parts.push(`${statementperiods} statement period(s)`);
		}

		if (terms_discount > 0) {
			parts.push(`${terms_discount}% discount`);
		}

		if (parts.length === 0) {
			return 'Custom configuration';
		}

		return parts.join(', ');
	}

	isProcessing: any = false;

	/** Clear spreadsheet preview, buckets, and file list (used after failed read, cancel, or full reset). */
	private clearPricebookUploadArtifacts(clearTablename: boolean): void {
		this.pricebookResumeOffer = null;
		if (this.pricebookScratchTablename) {
			const tn = this.pricebookScratchTablename;
			void this.inventoryService.discardPricebookStaging({ tablename: tn }).toPromise().catch(() => undefined);
		}
		if (this.pricebookApplyMappingTimer) {
			clearTimeout(this.pricebookApplyMappingTimer);
			this.pricebookApplyMappingTimer = null;
		}
		this.pricebookScratchTablename = null;
		this.pricebookUploadHeaderMeta = [];
		this.pricebookStagingRowsTotal = 0;
		this.pricebookMatchedStagingTotal = 0;
		this.pricebookUnmappedStagingTotal = 0;
		this.clearPricebookLookupMatchHighlights();
		this.resetPricebookViewPagers();
		this.files = [];
		this.uploaddata = false;
		this.mapping = {};
		this.matchedItems = [];
		this.unmatchedItems = [];
		this.mappedCount = 0;
		this.unmappedCount = 0;
		this.currentBatch = 0;
		this.totalBatches = 0;
		this.totalProcessed = 0;
		this.pricebookPostSummaryLines = null;
		this.isPostingBatches = false;
		this.postingCurrentBatch = 0;
		this.postingTotalBatches = 0;
		this.postingProcessed = 0;
		this.postingSucceeded = 0;
		this.postingFailed = 0;
		this.pricebookLookupTotalRows = 0;
		this.pricebookPostingTotalRows = 0;
		if (clearTablename) {
			this.tablename = '';
			this.salesTypeForm?.get('tablename')?.setValue('');
		}
	}

	private async yieldPricebookProgressUi(): Promise<void> {
		await new Promise<void>((resolve) => setTimeout(resolve, 0));
		this.cdr.detectChanges();
	}

	get pricebookLookupProgressPct(): number {
		if (!this.pricebookLookupTotalRows) {
			return 0;
		}
		return Math.min(100, Math.round((100 * this.totalProcessed) / this.pricebookLookupTotalRows));
	}

	get pricebookPostingProgressPct(): number {
		if (!this.pricebookPostingTotalRows) {
			return 0;
		}
		return Math.min(100, Math.round((100 * this.postingProcessed) / this.pricebookPostingTotalRows));
	}

	private resetPricebookViewPagers(): void {
		this.pricebookMapPageIndex = 0;
		this.pricebookMapPageSize = 50;
		this.pricebookMatchedPageIndex = 0;
		this.pricebookMatchedPageSize = 50;
		this.pricebookUnmatchedPageIndex = 0;
		this.pricebookUnmatchedPageSize = 50;
	}

	private clampPricebookViewPagers(): void {
		const clamp = (total: number, idx: number, size: number): number => {
			if (total <= 0 || size <= 0) {
				return 0;
			}
			const maxPage = Math.max(0, Math.ceil(total / size) - 1);
			return Math.max(0, Math.min(idx, maxPage));
		};
		const mapLen = this.pricebookScratchTablename
			? this.pricebookStagingRowsTotal
			: Array.isArray(this.uploaddata?.rows)
				? this.uploaddata.rows.length
				: 0;
		this.pricebookMapPageIndex = clamp(mapLen, this.pricebookMapPageIndex, this.pricebookMapPageSize);
		const matchedLen = this.pricebookScratchTablename ? this.pricebookMatchedStagingTotal : this.matchedItems.length;
		const unmappedLen = this.pricebookScratchTablename ? this.pricebookUnmappedStagingTotal : this.unmatchedItems.length;
		this.pricebookMatchedPageIndex = clamp(matchedLen, this.pricebookMatchedPageIndex, this.pricebookMatchedPageSize);
		this.pricebookUnmatchedPageIndex = clamp(unmappedLen, this.pricebookUnmatchedPageIndex, this.pricebookUnmatchedPageSize);
	}

	onPricebookMapPaginator(ev: PageEvent): void {
		this.pricebookMapPageIndex = ev.pageIndex;
		this.pricebookMapPageSize = ev.pageSize;
		this.clampPricebookViewPagers();
		if (this.pricebookScratchTablename) {
			void this.loadPricebookStagingMapPage();
		}
		this.cdr.detectChanges();
	}

	onPricebookMatchedPaginator(ev: PageEvent): void {
		this.pricebookMatchedPageIndex = ev.pageIndex;
		this.pricebookMatchedPageSize = ev.pageSize;
		this.clampPricebookViewPagers();
		if (this.pricebookScratchTablename) {
			void this.loadPricebookMatchedStagingPage();
		}
		this.cdr.detectChanges();
	}

	onPricebookUnmatchedPaginator(ev: PageEvent): void {
		this.pricebookUnmatchedPageIndex = ev.pageIndex;
		this.pricebookUnmatchedPageSize = ev.pageSize;
		this.clampPricebookViewPagers();
		if (this.pricebookScratchTablename) {
			void this.loadPricebookUnmappedStagingPage();
		}
		this.cdr.detectChanges();
	}

	get pricebookMapRowsPage(): any[] {
		const rows = this.uploaddata?.rows;
		if (!Array.isArray(rows) || !rows.length) {
			return [];
		}
		if (this.pricebookScratchTablename) {
			return rows;
		}
		const start = this.pricebookMapPageIndex * this.pricebookMapPageSize;
		return rows.slice(start, start + this.pricebookMapPageSize);
	}

	get pricebookMatchedItemsPage(): any[] {
		if (!this.matchedItems.length) {
			return [];
		}
		if (this.pricebookScratchTablename) {
			return this.matchedItems;
		}
		const start = this.pricebookMatchedPageIndex * this.pricebookMatchedPageSize;
		return this.matchedItems.slice(start, start + this.pricebookMatchedPageSize);
	}

	get pricebookUnmatchedItemsPage(): any[] {
		if (!this.unmatchedItems.length) {
			return [];
		}
		if (this.pricebookScratchTablename) {
			return this.unmatchedItems;
		}
		const start = this.pricebookUnmatchedPageIndex * this.pricebookUnmatchedPageSize;
		return this.unmatchedItems.slice(start, start + this.pricebookUnmatchedPageSize);
	}

	/** User chose another file or cancelled; abandon any in-flight parse for the previous selection. */
	private abandonPricebookParse(): void {
		this.pricebookParseNonce++;
	}

	resetPricebookUpload(): void {
		if (this.isSearching || this.isPostingBatches) {
			this.globalSearchService.showNotification(
				'Finish or wait for Find Missing Stock IDs / Final post before clearing the upload.',
				'warning',
				'bottom',
				'right'
			);
			return;
		}
		this.abandonPricebookParse();
		this.clearPricebookUploadArtifacts(true);
		this.isProcessing = false;
		this.cdr.detectChanges();
	}

	cancelPricebookParsing(): void {
		this.abandonPricebookParse();
		this.clearPricebookUploadArtifacts(false);
		this.isProcessing = false;
		this.cdr.detectChanges();
	}

	onSelect(event: any): void {
		const firstFile = event?.addedFiles?.[0];
		if (!firstFile) {
			return;
		}
		this.pricebookPostSummaryLines = null;
		this.files = [firstFile];
		this.isProcessing = true;
		this.uploaddata = false;
		this.matchedItems = [];
		this.unmatchedItems = [];
		this.currentBatch = 0;
		this.totalBatches = 0;
		this.totalProcessed = 0;
		this.mappedCount = 0;
		this.unmappedCount = 0;
		this.cdr.detectChanges();

		const run = async (): Promise<void> => {
			this.pricebookParseNonce++;
			const cap = this.pricebookParseNonce;
			try {
				const dataUrl = await this.readFileAsDataUrl(firstFile);
				await new Promise<void>((resolve) => setTimeout(resolve, 0));
				if (cap !== this.pricebookParseNonce) {
					return;
				}
				this.cdr.detectChanges();
				const typeabbrev = String(this.salesTypeForm?.get('typeabbrev')?.value || '').trim();
				const res: any = await this.inventoryService
					.uploadPriceBook({
						content: dataUrl,
						name: firstFile.name,
						typeabbrev,
					})
					.toPromise();
				if (cap !== this.pricebookParseNonce) {
					return;
				}
				if (!res?.success) {
					throw new Error(String(res?.error || 'Upload failed'));
				}
				this.pricebookResumeOffer = null;
				this.pricebookScratchTablename = res.tablename;
				this.pricebookUploadHeaderMeta = Array.isArray(res.header) ? res.header : [];
				this.pricebookStagingRowsTotal = Number(res.rowCount) || 0;
				this.tablename = res.tablename;
				this.salesTypeForm.get('tablename')?.setValue(res.tablename);
				const displayHeaders = this.pricebookUploadHeaderMeta.map((h: { original: string }) => h.original);
				const preview = Array.isArray(res.previewRows) ? res.previewRows : [];
				this.mapping = this.autoMapPricebookHeaders(displayHeaders);
				this.uploaddata = {
					header: displayHeaders,
					rows: preview.map((r: Record<string, unknown>) => this.stagingApiRowToDisplayRow(r)),
				};
				this.ensurePricebookScratchStockidColumn();
				this.matchedItems = [];
				this.unmatchedItems = [];
				this.resetPricebookViewPagers();
				await this.applyServerPricebookMappingAndRefresh();
				if (cap !== this.pricebookParseNonce) {
					return;
				}
				this.clampPricebookViewPagers();
				this.cdr.detectChanges();
			} catch (err: any) {
				if (cap !== this.pricebookParseNonce) {
					return;
				}
				this.globalSearchService.showNotification(
					String(err?.message || err || 'Upload failed. Run DB migration pricebook_staging_match_cache.sql if needed.'),
					'danger',
					'bottom',
					'right'
				);
				this.clearPricebookUploadArtifacts(false);
			} finally {
				if (cap === this.pricebookParseNonce) {
					this.isProcessing = false;
					this.cdr.detectChanges();
				}
			}
		};
		void run();
	}

	onUploadSuccess(event: any): void {
		this.uploaddata = event; // Assign the processed data
		this.isProcessing = false; // Stop the spinner
	}

	onRemove(file: any): void {
		this.files = this.files.filter(f => f !== file);
		if (this.files.length === 0) {
			this.abandonPricebookParse();
			this.clearPricebookUploadArtifacts(false);
			this.isProcessing = false;
			this.cdr.detectChanges();
		}
	}



	updatePriceBook() {

	}

	private readFileBuffer(file: File): Promise<ArrayBuffer> {
		return new Promise<ArrayBuffer>((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => {
				resolve(reader.result as ArrayBuffer);
			};
			reader.onerror = () => {
				reject(new Error('read_failed'));
			};
			reader.readAsArrayBuffer(file);
		});
	}

	private readFileAsDataUrl(file: File): Promise<string> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(String(reader.result || ''));
			reader.onerror = () => reject(new Error('read_failed'));
			reader.readAsDataURL(file);
		});
	}

	private stagingApiRowToDisplayRow(r: Record<string, unknown>): any {
		const o: any = {};
		for (const h of this.pricebookUploadHeaderMeta) {
			o[h.original] = r[h.column] != null ? r[h.column] : '';
		}
		const sid = r['stockid'] != null ? String(r['stockid']).trim() : '';
		o.stockid = sid;
		o._stockid_missing = !sid;
		return o;
	}

	private ensurePricebookScratchStockidColumn(): void {
		if (!this.pricebookScratchTablename || !this.uploaddata?.header?.length) {
			return;
		}
		if (this.uploaddata.header.includes('stockid')) {
			return;
		}
		this.uploaddata = {
			...this.uploaddata,
			header: [...this.uploaddata.header, 'stockid'],
			rows: Array.isArray(this.uploaddata.rows) ? this.uploaddata.rows : [],
		};
		this.mapping = { ...this.mapping, stockid: 'stockid' };
	}

	private wrapStagingRowForBuckets(r: any): any {
		const orig = this.stagingApiRowToDisplayRow(r);
		return {
			_originalRow: orig,
			stockid: String(r.stockid || '').trim(),
			brand: r.brand,
			partno: r.partno,
			price: r.price,
		};
	}

	private async loadPricebookStagingMapPage(): Promise<void> {
		if (!this.pricebookScratchTablename || !this.uploaddata?.header) {
			return;
		}
		const offset = this.pricebookMapPageIndex * this.pricebookMapPageSize;
		const res: any = await this.inventoryService
			.getPricebookStagingRows({
				tablename: this.pricebookScratchTablename,
				offset,
				limit: this.pricebookMapPageSize,
				filter: 'all',
			})
			.toPromise();
		if (!res?.success) {
			return;
		}
		this.uploaddata.rows = (res.rows || []).map((row: any) => this.stagingApiRowToDisplayRow(row));
		this.pricebookStagingRowsTotal = Number(res.total) || 0;
		this.ensurePricebookScratchStockidColumn();
	}

	private async loadPricebookMatchedStagingPage(): Promise<void> {
		if (!this.pricebookScratchTablename) {
			return;
		}
		const offset = this.pricebookMatchedPageIndex * this.pricebookMatchedPageSize;
		const res: any = await this.inventoryService
			.getPricebookStagingRows({
				tablename: this.pricebookScratchTablename,
				offset,
				limit: this.pricebookMatchedPageSize,
				filter: 'matched',
			})
			.toPromise();
		if (!res?.success) {
			return;
		}
		this.pricebookMatchedStagingTotal = Number(res.total) || 0;
		this.matchedItems = (res.rows || []).map((row: any) => this.wrapStagingRowForBuckets(row));
	}

	private async loadPricebookUnmappedStagingPage(): Promise<void> {
		if (!this.pricebookScratchTablename) {
			return;
		}
		const offset = this.pricebookUnmatchedPageIndex * this.pricebookUnmatchedPageSize;
		const res: any = await this.inventoryService
			.getPricebookStagingRows({
				tablename: this.pricebookScratchTablename,
				offset,
				limit: this.pricebookUnmatchedPageSize,
				filter: 'unmapped',
			})
			.toPromise();
		if (!res?.success) {
			return;
		}
		this.pricebookUnmappedStagingTotal = Number(res.total) || 0;
		this.unmatchedItems = (res.rows || []).map((row: any) => this.wrapStagingRowForBuckets(row));
	}

	private async refreshPricebookStagingBucketsAsync(): Promise<void> {
		if (!this.pricebookScratchTablename) {
			return;
		}
		const st: any = await this.inventoryService.getPricebookStagingStatus({ tablename: this.pricebookScratchTablename }).toPromise();
		if (!st?.success || !st.counts) {
			return;
		}
		this.mappedCount = Number(st.counts.matchedCount) || 0;
		this.unmappedCount = Number(st.counts.unmappedCount) || 0;
		await this.loadPricebookMatchedStagingPage();
		await this.loadPricebookUnmappedStagingPage();
	}

	private async checkPricebookStagingResume(): Promise<void> {
		if (this.pricebookScratchTablename) {
			return;
		}
		try {
			const res: any = await this.inventoryService.getPricebookStagingSession({}).toPromise();
			if (!res?.success || !res.hasSession || !res.tablename) {
				this.pricebookResumeOffer = null;
				return;
			}
			this.pricebookResumeOffer = {
				tablename: String(res.tablename),
				rowCount: Number(res.counts?.rowCount ?? res.session?.row_total) || 0,
				matchedCount: Number(res.counts?.matchedCount) || 0,
				postedCount: Number(res.counts?.postedCount) || 0,
				sourceFilename: String(res.session?.source_filename || ''),
			};
			this.cdr.markForCheck();
		} catch {
			this.pricebookResumeOffer = null;
		}
	}

	async continuePricebookStagingResume(): Promise<void> {
		if (!this.pricebookResumeOffer) {
			return;
		}
		const tn = this.pricebookResumeOffer.tablename;
		this.pricebookResumeOffer = null;
		try {
			await this.hydratePricebookStagingFromTablename(tn);
			this.globalSearchService.showNotification('Staging session loaded.', 'success', 'bottom', 'right');
		} catch (e: any) {
			this.globalSearchService.showNotification(String(e?.message || e), 'danger', 'bottom', 'right');
		}
		this.cdr.detectChanges();
	}

	async abandonPricebookStagingResumeOffer(): Promise<void> {
		if (!this.pricebookResumeOffer) {
			return;
		}
		const tn = this.pricebookResumeOffer.tablename;
		this.pricebookResumeOffer = null;
		try {
			await this.inventoryService.discardPricebookStaging({ tablename: tn }).toPromise();
		} catch {
			//
		}
		this.cdr.detectChanges();
	}

	private async hydratePricebookStagingFromTablename(tn: string): Promise<void> {
		const samp: any = await this.inventoryService
			.getPricebookStagingRows({ tablename: tn, offset: 0, limit: 1, filter: 'all' })
			.toPromise();
		if (!samp?.success || !Array.isArray(samp.rows) || !samp.rows.length) {
			throw new Error('Could not read staging table (empty or unauthorized).');
		}
		const row = samp.rows[0];
		const skip = new Set(['pb_row_id', 'stockid', 'posted_at']);
		const keys = Object.keys(row).filter((k) => !skip.has(k));
		this.pricebookUploadHeaderMeta = keys.map((k) => ({ original: k, column: k }));
		const headers = this.pricebookUploadHeaderMeta.map((h) => h.original);
		this.mapping = this.autoMapPricebookHeaders(headers);
		this.pricebookScratchTablename = tn;
		this.tablename = tn;
		this.salesTypeForm?.patchValue({ ispricebook: '1', tablename: tn }, { emitEvent: false });
		this.uploaddata = { header: headers, rows: [] };
		this.ensurePricebookScratchStockidColumn();
		const st: any = await this.inventoryService.getPricebookStagingStatus({ tablename: tn }).toPromise();
		if (st?.counts) {
			this.pricebookStagingRowsTotal = Number(st.counts.rowCount) || 0;
			this.mappedCount = Number(st.counts.matchedCount) || 0;
			this.unmappedCount = Number(st.counts.unmappedCount) || 0;
		}
		await this.applyServerPricebookMappingAndRefresh();
		this.clampPricebookViewPagers();
	}

	private async applyServerPricebookMappingAndRefresh(): Promise<void> {
		if (!this.pricebookScratchTablename || !this.mapping) {
			return;
		}
		try {
			const res: any = await this.inventoryService
				.applyPricebookStagingMapping({
					tablename: this.pricebookScratchTablename,
					mapping: this.mapping,
				})
				.toPromise();
			if (!res?.success) {
				throw new Error(String(res?.error || 'apply_failed'));
			}
			await this.loadPricebookStagingMapPage();
			await this.refreshPricebookStagingBucketsAsync();
			this.clampPricebookViewPagers();
			this.cdr.detectChanges();
		} catch (e: any) {
			this.globalSearchService.showNotification(String(e?.message || e), 'danger', 'bottom', 'right');
		}
	}

	private safeTableNameFromFile(fileName: string): string {
		const base = String(fileName || '')
			.replace(/\.[^/.]+$/, '')
			.toLowerCase()
			.replace(/[^a-z0-9_]+/g, '_')
			.replace(/^_+|_+$/g, '');
		return base ? `pricebook_${base}` : `pricebook_${Date.now()}`;
	}

	private autoMapPricebookHeaders(headers: string[]): Record<string, string> {
		const mapping: Record<string, string> = {};
		const used = new Set<string>();

		const rules: Array<{ test: (h: string) => boolean; value: string }> = [
			{ test: h => h === 'stockid' || h === 'stock_id' || h === 'itemno' || h === 'item_no' || /\bstockid\b/.test(h), value: 'stockid' },
			{ test: h => h === 'brand' || /\bbrand\b/.test(h) || h.includes('manufacturer'), value: 'brand' },
			{ test: h => h === 'partno' || h === 'part_no' || h === 'mfgpart' || /\bpart\s*(no|num|number)\b/.test(h), value: 'partno' },
			{ test: h => h === 'price' || /\bprice\b/.test(h), value: 'price' },
		];

		for (const header of headers) {
			const h = String(header || '').toLowerCase().trim();
			let field = 'ignore';
			for (const rule of rules) {
				if (!used.has(rule.value) && rule.test(h)) {
					field = rule.value;
					used.add(rule.value);
					break;
				}
			}
			mapping[header] = field;
		}
		return mapping;
	}

	clearPricebookLookupMatchHighlights(): void {
		const rows = this.uploaddata?.rows;
		if (Array.isArray(rows)) {
			for (const row of rows) {
				if (row && typeof row === 'object') {
					delete (row as any)._pricebookLookupMatched;
				}
			}
		}
		this.pricebookLastLookupNewMatchCount = 0;
		this.cdr.detectChanges();
	}

	onMappingChanged(): void {
		this.clearPricebookLookupMatchHighlights();
		if (this.pricebookScratchTablename) {
			if (this.pricebookApplyMappingTimer) {
				clearTimeout(this.pricebookApplyMappingTimer);
			}
			this.pricebookApplyMappingTimer = setTimeout(() => {
				this.pricebookApplyMappingTimer = null;
				void this.applyServerPricebookMappingAndRefresh();
			}, 350);
			return;
		}
		this.refreshMatchBuckets();
	}

	private mappedRowsForPricebook(): any[] {
		const rows = this.uploaddata?.rows || [];
		const headers = this.uploaddata?.header || [];
		return rows.map((row: any) => {
			const mapped: any = { _originalRow: row };
			for (const header of headers) {
				const target = this.mapping[header];
				if (!target) {
					continue;
				}
				mapped[target] = row[header];
			}
			mapped.stockid = String(mapped.stockid || '').trim();
			return mapped;
		});
	}

	private refreshMatchBuckets(): void {
		if (this.pricebookScratchTablename) {
			void this.refreshPricebookStagingBucketsAsync().then(() => {
				this.clampPricebookViewPagers();
				this.cdr.detectChanges();
			});
			return;
		}
		const mappedRows = this.mappedRowsForPricebook();
		this.matchedItems = mappedRows.filter((r) => !!String(r.stockid || '').trim());
		this.unmatchedItems = mappedRows.filter((r) => !String(r.stockid || '').trim());
		this.mappedCount = this.matchedItems.length;
		this.unmappedCount = this.unmatchedItems.length;
		this.clampPricebookViewPagers();
	}

	private hasMappedField(fieldName: string): boolean {
		return Object.values(this.mapping || {}).includes(fieldName);
	}

	getEffectivePricebookBatchSize(): number {
		const n = Math.floor(Number(this.pricebookBatchLimit));
		if (!Number.isFinite(n) || n < this.pricebookBatchLimitMin) {
			return this.pricebookBatchLimitDefault;
		}
		return Math.min(this.pricebookBatchLimitMax, Math.max(this.pricebookBatchLimitMin, n));
	}

	get canFinalizePricebookPost(): boolean {
		const hasMatches = this.pricebookScratchTablename ? this.mappedCount > 0 : this.matchedItems.length > 0;
		return hasMatches && this.hasMappedField('price') && !this.isSearching && !this.isPostingBatches;
	}

	get pricebookMatchedDisplayCount(): number {
		return this.pricebookScratchTablename ? this.mappedCount : this.matchedItems.length;
	}

	get pricebookUnmappedDisplayCount(): number {
		return this.pricebookScratchTablename ? this.unmappedCount : this.unmatchedItems.length;
	}

	private pricebookExportFileBase(): string {
		const typeabbrev = String(this.salesTypeForm?.get('typeabbrev')?.value || '').trim().toUpperCase();
		const base = String(this.tablename || 'pricebook').replace(/[^\w.-]+/g, '_');
		return typeabbrev ? `${base}_${typeabbrev}` : base;
	}

	private writePricebookRowsXlsx(sheetLabel: string, headers: string[], rows: Record<string, unknown>[]): void {
		if (!headers.length) {
			return;
		}
		const safeSheet = sheetLabel.replace(/[[\]:*?/\\]/g, '_').slice(0, 31) || 'Sheet1';
		const ws = XLSX.utils.json_to_sheet(rows.length ? rows : [{}], { header: headers });
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, safeSheet);
		const ymd = new Date().toISOString().slice(0, 10);
		const base = this.pricebookExportFileBase();
		XLSX.writeFile(wb, `${base}_${sheetLabel}_${ymd}.xlsx`);
	}

	exportMatchedPricebookXlsx(): void {
		const headers = this.uploaddata?.header || [];
		if (!headers.length || !this.matchedItems.length) {
			this.globalSearchService.showNotification('No matched rows to export.', 'info', 'bottom', 'right');
			return;
		}
		const rows = this.matchedItems.map((item) => {
			const src = item?._originalRow || {};
			const o: Record<string, unknown> = {};
			for (const h of headers) {
				o[h] = src[h];
			}
			return o;
		});
		this.writePricebookRowsXlsx('matched', headers, rows);
		this.globalSearchService.showNotification('Matched rows exported to Excel.', 'success', 'bottom', 'right');
	}

	async exportUnmappedPricebookXlsx(): Promise<void> {
		const headers = this.uploaddata?.header || [];
		if (!headers.length) {
			this.globalSearchService.showNotification('No unmapped rows to export.', 'info', 'bottom', 'right');
			return;
		}

		let allUnmatched: any[] = [];

		if (this.pricebookScratchTablename) {
			// Staging mode: this.unmatchedItems holds only the current display page (50 rows).
			// Fetch every unmapped row from the server in 500-row batches.
			const batchSize = 500;
			let offset = 0;
			let total = this.pricebookUnmappedStagingTotal || 1;
			while (offset < total) {
				const res: any = await this.inventoryService
					.getPricebookStagingRows({
						tablename: this.pricebookScratchTablename,
						offset,
						limit: batchSize,
						filter: 'unmapped',
					})
					.toPromise();
				if (!res?.success) { break; }
				total = Number(res.total) || total;
				const batch = (res.rows || []).map((row: any) => this.wrapStagingRowForBuckets(row));
				allUnmatched = allUnmatched.concat(batch);
				offset += batchSize;
			}
		} else {
			// In-memory mode: all rows are already loaded.
			allUnmatched = this.unmatchedItems;
		}

		if (!allUnmatched.length) {
			this.globalSearchService.showNotification('No unmapped rows to export.', 'info', 'bottom', 'right');
			return;
		}

		const rows = allUnmatched.map((item) => {
			const src = item?._originalRow || {};
			const o: Record<string, unknown> = {};
			for (const h of headers) {
				o[h] = src[h];
			}
			return o;
		});
		this.writePricebookRowsXlsx('unmapped', headers, rows);
		this.globalSearchService.showNotification(`${allUnmatched.length} unmapped rows exported to Excel.`, 'success', 'bottom', 'right');
	}

	async searchMissingPricebookStockIds(): Promise<void> {
		if (!this.uploaddata?.header?.length) {
			return;
		}
		if (!this.hasMappedField('brand') || !this.hasMappedField('partno')) {
			this.globalSearchService.showNotification('Map both Brand and Part Number before lookup.', 'warning', 'bottom', 'right');
			return;
		}

		if (this.pricebookScratchTablename) {
			await this.applyServerPricebookMappingAndRefresh();
			const st0: any = await this.inventoryService
				.getPricebookStagingStatus({ tablename: this.pricebookScratchTablename })
				.toPromise();
			if (st0?.counts && Number(st0.counts.unmappedCount) === 0) {
				this.globalSearchService.showNotification('All rows already have a stock ID.', 'info', 'bottom', 'right');
				return;
			}
			this.clearPricebookLookupMatchHighlights();
			this.pricebookLastLookupNewMatchCount = 0;
			const totalRows = Math.max(1, Number(st0?.counts?.rowCount) || this.pricebookStagingRowsTotal);
			this.pricebookLookupTotalRows = totalRows;
			this.isSearching = true;
			this.currentBatch = 0;
			this.totalProcessed = 0;
			this.totalBatches = 0;
			this.cdr.detectChanges();
			let afterId = 0;
			let batchNum = 0;
			try {
				while (true) {
					batchNum++;
					this.currentBatch = batchNum;
					const res: any = await this.inventoryService
						.matchItems({
							tablename: this.pricebookScratchTablename,
							afterId,
							batchSize: this.getEffectivePricebookBatchSize(),
						})
						.toPromise();
					if (!res?.success) {
						throw new Error(String(res?.error || 'match_failed'));
					}
					this.totalProcessed += Number(res.batchIds) || 0;
					this.pricebookLastLookupNewMatchCount += Number(res.joinUpdated || 0) + Number(res.cacheHits || 0);
					await this.loadPricebookStagingMapPage();
					await this.refreshPricebookStagingBucketsAsync();
					this.cdr.detectChanges();
					if (res.done) {
						break;
					}
					afterId = Number(res.nextAfterId) || 0;
					await this.yieldPricebookProgressUi();
				}
				const tail = `Matched ${this.mappedCount}, Unmapped ${this.unmappedCount}.`;
				const msg =
					this.pricebookLastLookupNewMatchCount > 0
						? `Match complete. ${this.pricebookLastLookupNewMatchCount} cell update(s) from server batches. ${tail}`
						: `Match complete. ${tail}`;
				this.globalSearchService.showNotification(msg, this.unmappedCount ? 'warning' : 'success', 'bottom', 'right');
			} catch (e: any) {
				this.globalSearchService.showNotification(String(e?.message || e), 'danger', 'bottom', 'right');
			} finally {
				this.isSearching = false;
				this.pricebookLookupTotalRows = 0;
				this.cdr.detectChanges();
			}
			return;
		}

		const candidates = this.mappedRowsForPricebook().filter((r) => !r.stockid && r.brand && r.partno);
		if (!candidates.length) {
			this.refreshMatchBuckets();
			return;
		}

		this.clearPricebookLookupMatchHighlights();
		this.pricebookLookupTotalRows = candidates.length;
		this.isSearching = true;
		this.currentBatch = 0;
		this.totalProcessed = 0;
		const batchSize = this.getEffectivePricebookBatchSize();
		this.totalBatches = Math.ceil(candidates.length / batchSize);
		this.cdr.detectChanges();

		try {
			for (let i = 0; i < candidates.length; i += batchSize) {
				const batch = candidates.slice(i, i + batchSize);
				this.currentBatch = Math.floor(i / batchSize) + 1;
				this.totalProcessed += batch.length;
				this.cdr.detectChanges();
				try {
					const res: any = await this.inventoryService.lookupMissingSkus(batch).toPromise();
					const found = Array.isArray(res?.results) ? res.results : [];
					const map = new Map<string, string>();
					for (const row of found) {
						const key = `${String(row.brand || '').toLowerCase()}||${String(row.partno || '').toLowerCase()}`;
						map.set(key, String(row.stockid || ''));
					}
					for (const row of batch) {
						const key = `${String(row.brand || '').toLowerCase()}||${String(row.partno || '').toLowerCase()}`;
						const stockid = map.get(key);
						if (stockid) {
							const orig = row._originalRow;
							orig.stockid = stockid;
							orig._pricebookLookupMatched = true;
							this.pricebookLastLookupNewMatchCount++;
						}
					}
				} catch (e) {
					// continue remaining batches
				}
				this.refreshMatchBuckets();
				await this.yieldPricebookProgressUi();
			}

			const newMatches = this.pricebookLastLookupNewMatchCount;
			const tail = `Matched ${this.matchedItems.length}, Unmapped ${this.unmatchedItems.length}.`;
			const msg =
				newMatches > 0
					? `Lookup complete. ${newMatches} row(s) newly linked to a stock ID (highlighted in the sheet). ${tail}`
					: `Lookup complete. ${tail}`;
			this.globalSearchService.showNotification(msg, this.unmatchedItems.length ? 'warning' : 'success', 'bottom', 'right');
		} finally {
			this.isSearching = false;
			this.pricebookLookupTotalRows = 0;
			this.cdr.detectChanges();
		}
	}

	async postPricebookBatches(): Promise<void> {
		const typeabbrev = String(this.salesTypeForm.get('typeabbrev')?.value || '').trim().toUpperCase();
		if (!typeabbrev) {
			this.globalSearchService.showNotification('Sales Type is required before posting.', 'warning', 'bottom', 'right');
			return;
		}
		if (!this.hasMappedField('price')) {
			this.globalSearchService.showNotification('Map a Price column before posting.', 'warning', 'bottom', 'right');
			return;
		}

		if (this.pricebookScratchTablename) {
			await this.refreshPricebookStagingBucketsAsync();
			if (this.mappedCount < 1) {
				this.globalSearchService.showNotification('No matched rows to post.', 'warning', 'bottom', 'right');
				return;
			}
			this.pricebookPostSummaryLines = null;
			this.isPostingBatches = true;
			this.postingCurrentBatch = 0;
			this.postingProcessed = 0;
			this.postingSucceeded = 0;
			this.postingFailed = 0;
			const batchSize = Math.min(500, this.getEffectivePricebookBatchSize());
			this.postingTotalBatches = 0;
			this.pricebookPostingTotalRows = Math.max(1, this.mappedCount);
			this.cdr.detectChanges();
			let afterId = 0;
			let serverUpdated = 0;
			let serverSkipped = 0;
			let batchIx = 0;
			try {
				while (true) {
					batchIx++;
					this.postingCurrentBatch = batchIx;
					const res: any = await this.inventoryService
						.processSalesTypePricing({
							typeabbrev,
							tablename: this.pricebookScratchTablename,
							afterId,
							batchSize,
						})
						.toPromise();
					if (res?.success === false || res?.error) {
						throw new Error(String(res?.error || 'batch_failed'));
					}
					const proc = Number(res?.processed) || 0;
					this.postingProcessed += proc;
					this.postingSucceeded += Number(res?.updated) || 0;
					serverUpdated += Number(res?.updated) || 0;
					serverSkipped += Number(res?.skipped) || 0;
					if (res?.done) {
						break;
					}
					afterId = Number(res?.nextAfterId) || 0;
					await this.yieldPricebookProgressUi();
				}
				await this.refreshPricebookStagingBucketsAsync();
			} catch (e) {
				this.postingFailed += 1;
			} finally {
				this.isPostingBatches = false;
				this.pricebookPostingTotalRows = 0;
				this.cdr.detectChanges();
			}
			const summary: string[] = [
				`Sales type: ${typeabbrev}`,
				`Posted from staging table ${this.pricebookScratchTablename} in server batches (max ${batchSize} rows per request).`,
				`Server wrote ${serverUpdated} price row(s); skipped ${serverSkipped}.`,
			];
			if (this.postingFailed > 0) {
				summary.push('One or more posting batches failed.');
			}
			this.pricebookPostSummaryLines = summary;
			this.globalSearchService.showNotification(
				`Posting complete. ${serverUpdated} updated, ${serverSkipped} skipped.`,
				this.postingFailed ? 'warning' : 'success',
				'bottom',
				'right'
			);
			this.cdr.detectChanges();
			return;
		}

		this.refreshMatchBuckets();
		if (!this.matchedItems.length) {
			this.globalSearchService.showNotification('No matched rows to post.', 'warning', 'bottom', 'right');
			return;
		}

		this.pricebookPostSummaryLines = null;
		this.isPostingBatches = true;
		this.postingCurrentBatch = 0;
		this.postingProcessed = 0;
		this.postingSucceeded = 0;
		this.postingFailed = 0;
		const batchSize = this.getEffectivePricebookBatchSize();
		const rows = this.matchedItems.map((item) => ({
			stockid: item.stockid,
			brand: item.brand,
			partno: item.partno,
			price: item.price,
		}));
		this.postingTotalBatches = Math.ceil(rows.length / batchSize);
		this.pricebookPostingTotalRows = rows.length;
		this.cdr.detectChanges();
		let serverProcessed = 0;
		let serverUpdated = 0;
		let serverSkipped = 0;
		try {
			for (let i = 0; i < rows.length; i += batchSize) {
				const batch = rows.slice(i, i + batchSize);
				this.postingCurrentBatch = Math.floor(i / batchSize) + 1;
				this.postingProcessed += batch.length;
				this.cdr.detectChanges();
				try {
					const res: any = await this.inventoryService.processSalesTypePricing({ typeabbrev, rows: batch }).toPromise();
					if (res?.success === false || res?.error) {
						throw new Error(String(res?.error || 'batch_failed'));
					}
					this.postingSucceeded += batch.length;
					serverProcessed += Number(res?.processed) || batch.length;
					serverUpdated += Number(res?.updated) || 0;
					serverSkipped += Number(res?.skipped) || 0;
				} catch (e) {
					this.postingFailed += batch.length;
				}
				await this.yieldPricebookProgressUi();
			}
		} finally {
			this.isPostingBatches = false;
			this.pricebookPostingTotalRows = 0;
			this.cdr.detectChanges();
		}
		const skippedPreview = this.unmatchedItems.length;
		const summary: string[] = [
			`Sales type: ${typeabbrev}`,
			`Rows sent: ${rows.length} in ${this.postingTotalBatches} batch(es) (max ${batchSize} per request).`,
			...(skippedPreview > 0
				? [`${skippedPreview} spreadsheet row(s) had no stock ID and were not sent (only matched rows are posted).`]
				: []),
			`Server wrote ${serverUpdated} price row(s); skipped ${serverSkipped} (no stock ID in master, blank price, or non-numeric price).`,
		];
		if (this.postingFailed > 0) {
			summary.push(`Failed to complete ${this.postingFailed} row(s) (one or more batches returned an error).`);
		}
		this.pricebookPostSummaryLines = summary;
		this.globalSearchService.showNotification(
			`Posting complete. ${serverUpdated} updated, ${serverSkipped} skipped, ${this.postingFailed} failed batch row(s).`,
			this.postingFailed ? 'warning' : 'success',
			'bottom',
			'right'
		);
		this.cdr.detectChanges();
	}


	editPaymentTermDispaly(atype: any) {
		this.isEditingPaymentTerm = true;
		this.isLoading = true;

		// Detect due date type from existing values
		let dueDateType = 'days';
		const daysbeforedue = parseInt(atype.daysbeforedue) || 0;
		const dayinfollowingmonth = parseInt(atype.dayinfollowingmonth) || 0;
		if (dayinfollowingmonth > 0 && dayinfollowingmonth < 31) {
			dueDateType = 'dayOfMonth';
		} else if (dayinfollowingmonth === 31 || (daysbeforedue === 0 && dayinfollowingmonth > 0)) {
			dueDateType = 'endOfMonth';
		} else if (daysbeforedue > 0) {
			dueDateType = 'days';
		}

		this.paymentTermsForm = this.fb.group({
			dueDateType: [dueDateType],
			termsindicator: [atype.termsindicator, Validators.required],
			terms: [atype.terms, Validators.required],
			daysbeforedue: [atype.daysbeforedue, Validators.required],
			dayinfollowingmonth: [atype.dayinfollowingmonth, Validators.required],
			statementperiods: [atype.statementperiods || atype.statementperios || '0', Validators.required],
			terms_discount: [atype.terms_discount || '0.00', [Validators.required, Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
			numpayments: [atype.numpayments || '1', [Validators.required, Validators.min(1)]],
			cc_process: [atype.cc_process, Validators.required],
			decline: [atype.decline, Validators.required],
			collect_payment: [atype.collect_payment, Validators.required],
			donot_print: [atype.donot_print, Validators.required],
			onaccountallowed: [atype.onaccountallowed, Validators.required],
			order_entry: [atype.order_entry, Validators.required],
			agefrom: [atype.agefrom || '1'],
			ageto: [atype.ageto || null],
		});

		this.exampleTranDate.setValue(new Date());
		this.startDueDateListeners();
		this.getExampleDueDate();

		this.modalService.open(this.addPaymentTermref, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {
			this.isEditingPaymentTerm = false;
		}, (reason) => {
			this.isEditingPaymentTerm = false;
		});

		this.isLoading = false;
	}

	editCustomerTypeDisplay(atype: any) {
		this.isLoading = true;

		this.customerTypeForm = this.fb.group({
			typeid: [atype.typeid],
			typename: [atype.typename, Validators.required],
			address_type: [atype.address_type, Validators.required],
		});


		this.modalService.open(this.addcustomeref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {

		});

		this.isLoading = false;

	}

	editCustomerType(type: any) {
		this.isLoading = true
		if (this.customerTypeForm.valid) {
			this.globalsService.saveCustomerType(this.customerTypeForm.value).subscribe(result => {
				this.customertypes = result;
				this.modalService.dismissAll();
			});
		}

		this.isLoading = false
	}

	removeCustomerType(type: any) {
		this.isLoading = true

		this.globalsService.removeCustomerType(type).subscribe(result => {
			this.customertypes = result;
		});

		this.isLoading = false
	}

	addCustomerType() {
		this.isLoading = true

		if (this.customerTypeForm.valid) {
			this.globalsService.saveCustomerType(this.customerTypeForm.value).subscribe(result => {
				this.customertypes = result;
				this.modalService.dismissAll();
			});
		}

		this.isLoading = false
	}
	typechange() {

		this.editrule_type = this.exclusionForm.get('rule_type').value;
	}
	editCustomerTypeExclusions(custtype: any) {

		this.editrule_type = 'P';
		const data = { 'typeid': custtype.typeid };
		this.editrule_name = custtype.typename;
		this.currenttype = custtype.typeid;
		this.currentrule = '';
		this.globalsService.getTypeExclusionRules(data).subscribe((a) => {
			this.ruleset = a;

			this.exclusionForm = this.fb.group({
				'rule_type': ['', Validators.required],
				'rule_inclusive': ['1'],
				'rule_value': ['', Validators.required],
			});
			this.modalService.open(this.ruleRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {

			});
		});
	}
	editRule(rule: any) {

		this.editrule_type = rule.ruletype;
		this.currentrule = rule.id;
		this.exclusionForm = this.fb.group({
			rule_type: [rule.ruletype, Validators.required],
			rule_value: [rule.rulevalue, Validators.required],
			rule_inclusive: [rule.inclusive, Validators.required],
		});
	}
	deleteRule(ruleid: any) {
		const data = {
			'typeid': this.currenttype,
			'id': ruleid.id,
		};

		this.globalsService.deleteExclusionRule(data).subscribe(r => {
			this.ruleset = r;
		});

	}
	saveRule() {

		const data = {
			'typeid': this.currenttype,
			'id': this.currentrule,
			'rule_type': this.exclusionForm.get('rule_type').value,
			'rule_value': this.exclusionForm.get('rule_value').value,
			'rule_inclusive': this.exclusionForm.get('rule_inclusive').value
		};

		this.globalsService.saveExclusionRule(data).subscribe(r => {
			this.ruleset = r;
			this.currentrule = '';
			this.exclusionForm.get('rule_value').setValue('');
			this.exclusionForm.get('rule_type').setValue('');
		});
	}
	addPaymentTermView() {
		this.isEditingPaymentTerm = false;
		this.isLoading = true;

		this.paymentTermsForm = this.fb.group({
			dueDateType: ['days'],
			termsindicator: ['', Validators.required],
			terms: ['', Validators.required],
			daysbeforedue: ['0', Validators.required],
			dayinfollowingmonth: ['0', Validators.required],
			statementperiods: ['0', Validators.required],
			terms_discount: ['0.00', [Validators.required, Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]],
			numpayments: ['1', [Validators.required, Validators.min(1)]],
			cc_process: ['0', Validators.required],
			decline: ['0', Validators.required],
			collect_payment: ['0', Validators.required],
			donot_print: ['0', Validators.required],
			onaccountallowed: ['0', Validators.required],
			order_entry: ['1', Validators.required],
			agefrom: ['1'],
			ageto: [null],
		});

		this.exampleTranDate.setValue(new Date());
		this.startDueDateListeners();
		this.getExampleDueDate();

		this.modalService.open(this.addPaymentTermref, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then((result) => {
			this.isEditingPaymentTerm = false;
		}, (reason) => {
			this.isEditingPaymentTerm = false;
		});
		this.isLoading = false;
	}


	addCustomerTypeView() {
		this.isLoading = true

		this.modalService.open(this.addcustomeref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

		this.isLoading = false
	}

	addVendorTypeDisplay() {
		this.isLoading = true

		this.modalService.open(this.addvendorref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

		this.isLoading = false
	}

	productTypeFlagOn(v: any): boolean {
		return v === 1 || v === true || v === '1';
	}

	loadProductTypes(): void {
		this.fetchProductTypesWithRecovery(0);
	}

	private fetchProductTypesWithRecovery(attempt: number): void {
		this.productTypesLoading = true;
		this.globalsService.getProductTypes().pipe(
			finalize(() => {
				this.productTypesLoading = false;
			})
		).subscribe({
			next: (rows: any) => {
				this.productTypes = Array.isArray(rows) ? rows : [];
			},
			error: () => {
				this.productTypes = [];
				if (attempt < 1) {
					this.globalSearchService.reload();
					setTimeout(() => this.fetchProductTypesWithRecovery(attempt + 1), 750);
				}
			},
		});
	}

	addProductTypeDisplay() {
		this.productTypeForm.reset({
			label: '',
			original_label: '',
			description: '',
			createmovements: true,
			isdefault: false,
			haschildren: false,
			requiresconfig: false,
			requirespick: true,
			reducesstock: true,
		});
		this.productTypeForm.get('label').enable();
		this.modalService.open(this.addproducttyperef, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then(() => { }, () => { });
	}

	editProductTypeDisplay(row: any) {
		this.productTypeForm.patchValue({
			label: row.label,
			original_label: row.label,
			description: row.description || '',
			createmovements: this.productTypeFlagOn(row.createmovements),
			isdefault: this.productTypeFlagOn(row.isdefault),
			haschildren: this.productTypeFlagOn(row.haschildren),
			requiresconfig: this.productTypeFlagOn(row.requiresconfig),
			requirespick: this.productTypeFlagOn(row.requirespick),
			reducesstock: this.productTypeFlagOn(row.reducesstock),
		});
		this.productTypeForm.get('label').enable();
		this.modalService.open(this.addproducttyperef, { ariaLabelledBy: 'modal-title', size: 'lg' }).result.then(() => { }, () => { });
	}

	saveProductType(modal: any) {
		if (!this.productTypeForm.valid || this.productTypeSaving) {
			return;
		}
		const raw = this.productTypeForm.getRawValue();
		const label = String(raw.label || '').trim().toUpperCase().substring(0, 1);
		const origRaw = String(raw.original_label || '').trim();
		const original_label = origRaw.length === 1 ? origRaw.toUpperCase() : '';
		const payload = {
			label,
			original_label,
			description: String(raw.description || '').trim(),
			createmovements: raw.createmovements ? 1 : 0,
			isdefault: raw.isdefault ? 1 : 0,
			haschildren: raw.haschildren ? 1 : 0,
			requiresconfig: raw.requiresconfig ? 1 : 0,
			requirespick: raw.requirespick ? 1 : 0,
			reducesstock: raw.reducesstock ? 1 : 0,
		};
		if (payload.label.length !== 1) {
			return;
		}
		this.productTypeSaving = true;
		this.globalsService.saveProductType(payload).pipe(
			finalize(() => {
				this.productTypeSaving = false;
			})
		).subscribe({
			next: (res: any) => {
				if (!res || res.success === false) {
					alert((res && res.message) || 'Could not save product type.');
					return;
				}
				if (!Array.isArray(res.producttypes)) {
					alert('Unexpected response from server.');
					return;
				}
				this.productTypes = res.producttypes;
				if (modal && typeof modal.close === 'function') {
					modal.close('saved');
				} else {
					this.modalService.dismissAll();
				}
			},
			error: () => {
				alert('Save failed. Check your connection and try again.');
			},
		});
	}

	removeProductType(row: any) {
		if (!confirm('Remove product type / MB flag "' + row.label + '"?')) {
			return;
		}
		this.globalsService.removeProductType({ label: row.label }).subscribe({
			next: (res: any) => {
				if (!res || res.success === false) {
					alert((res && res.message) || 'Could not remove product type.');
					return;
				}
				if (Array.isArray(res.producttypes)) {
					this.productTypes = res.producttypes;
				}
			},
			error: () => {
				alert('Remove failed. Check your connection and try again.');
			},
		});
	}

	editVendorTypeDisplay(atype: any) {
		this.isLoading = true

		this.vendorTypeForm = this.fb.group({
			typeid: [atype.typeid],
			typename: [atype.typename, Validators.required],
		});

		this.modalService.open(this.addvendorref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

		this.isLoading = false
	}

	removeVendorType(type: any) {
		this.isLoading = true

		this.globalsService.removeVendorType(type).subscribe(result => {
			this.supptypes = result;
		});

		this.isLoading = false
	}

	editSalesTypeDispaly(atype: any) {
		this.salesTypeSaveResult = null;
		this.pricebookPostSummaryLines = null;
		this.salesTypeForm = this.fb.group({
			typeabbrev: [atype.typeabbrev, Validators.required],
			sales_type: [atype.sales_type, Validators.required],
			costMultiplier: [atype.costMultiplier ?? '1', Validators.required],
			loyaltypoints: [atype.loyaltypoints, Validators.required],
			ispricebook: [atype.ispricebook, Validators.required],
			fallback: [atype.fallback],
			newpricebook: [false],
			tablename: [''],
		});
		this.uploaddata = false;
		this.files = [];
		this.mapping = {};
		this.matchedItems = [];
		this.unmatchedItems = [];
		this.tablename = '';
		this.resetPricebookViewPagers();

		this.modalService.open(this.addsalestyperef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

	}

	addVendorType() {
		if (this.vendorTypeForm.valid) {
			this.globalsService.saveVendorType(this.vendorTypeForm.value).subscribe(result => {
				this.supptypes = result;
				this.modalService.dismissAll();
			});
		}
	}

	editSalesType(type: any) {

	}

	removeSalesType(type: any) {
		//TODO! PREVENT THIS IF CUSTOMERS SETUP @ PRICE TYPE
		const confirm_remove = confirm('Remove sales type ' + type.typeabbrev + '?');
		if (confirm_remove) {
			this.globalsService.removeSalesType(type).subscribe(result => {
				this.salestypes = result;
			});
		}
	}

	removePaymentTerm(type: any) {
		//TODO! PREVENT THIS
		const confirm_remove = confirm('Remove Term ' + type.typename + '?');
		if (confirm_remove) {
			this.globalsService.removePaymentTerm(type).subscribe(result => {
				this.payment_terms = result;
			});
		}

	}

	addPaymentTerm() {
		if (this.paymentTermsForm.valid) {
			const formValue = { ...this.paymentTermsForm.value };

			if (!this.validatePaymentTermFields(formValue)) {
				return;
			}

			delete formValue.dueDateType; // Remove UI-only field

			if (formValue.termsindicator && formValue.termsindicator.length > 4) {
				this.globalSearchService.showNotification('Payment term code must be 4 characters or less', 'danger', 'bottom', 'right');
				return;
			}

			if (!this.isEditingPaymentTerm) {
				const existingTerm = this.payment_terms.find(t => t.termsindicator === formValue.termsindicator);
				if (existingTerm) {
					this.globalSearchService.showNotification('Payment term code already exists. Please use edit instead.', 'danger', 'bottom', 'right');
					return;
				}
			}

			if (this.isEditingPaymentTerm) {
				formValue._is_update = true;
			}

			this.globalsService.savePaymentTerm(formValue).subscribe(result => {
				if (result && result.error) {
					this.globalSearchService.showNotification(result.error, 'danger', 'bottom', 'right');
				} else {
					this.payment_terms = result;
					this.globalsService.getTerms().subscribe(terms => {
						this.globalSearchService.terms.next(terms);
					});
					this.modalService.dismissAll();
					this.isEditingPaymentTerm = false;
					this.globalSearchService.showNotification('Payment term saved successfully', 'success', 'bottom', 'right');
				}
			}, error => {
				this.globalSearchService.showNotification('Error saving payment term', 'danger', 'bottom', 'right');
			});
		}
	}

	validatePaymentTermFields(formValue: any): boolean {
		const dueDateType = formValue.dueDateType;
		const daysbeforedue = parseInt(formValue.daysbeforedue) || 0;
		const dayinfollowingmonth = parseInt(formValue.dayinfollowingmonth) || 0;

		if (!dueDateType) {
			this.globalSearchService.showNotification('Please select when payment is due', 'danger', 'bottom', 'right');
			return false;
		}

		if (dueDateType === 'days' && daysbeforedue === 0) {
			this.globalSearchService.showNotification('Please enter number of days', 'danger', 'bottom', 'right');
			return false;
		}

		if (dueDateType === 'dayOfMonth' && (dayinfollowingmonth === 0 || dayinfollowingmonth > 31)) {
			this.globalSearchService.showNotification('Please enter a valid day of month (1-31)', 'danger', 'bottom', 'right');
			return false;
		}

		return true;
	}

	addSalesTypeDisplay() {
		this.salesTypeSaveResult = null;
		this.pricebookPostSummaryLines = null;
		this.salesTypeForm.reset();
		this.uploaddata = false;
		this.files = [];
		this.mapping = {};
		this.matchedItems = [];
		this.unmatchedItems = [];
		this.tablename = '';
		this.resetPricebookViewPagers();
		this.modalService.open(this.addsalestyperef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}

	dismissSalesTypeSavePanel(): void {
		this.salesTypeSaveResult = null;
		this.cdr.detectChanges();
	}

	closeSalesTypeModalAfterSave(): void {
		this.salesTypeSaveResult = null;
		this.modalService.dismissAll();
		this.cdr.detectChanges();
	}

	private buildSalesTypeSavePayload(): any {
		const payload = { ...this.salesTypeForm.value };
		if (String(payload.ispricebook) === '1' && this.pricebookScratchTablename) {
			payload.tablename = '';
		}
		return payload;
	}

	private salesTypeFallbackLabel(code: string): string {
		const c = String(code || '').trim();
		if (!c) {
			return '(none)';
		}
		const list = Array.isArray(this.salestypes) ? this.salestypes : [];
		const row = list.find((t: any) => String(t?.typeabbrev || '').trim() === c);
		return row ? `${c} — ${String(row.sales_type || '').trim()}` : c;
	}

	private buildSalesTypeSaveSummaryLines(result: any): string[] {
		const fv = this.salesTypeForm.getRawValue();
		const typeabbrev = String(fv.typeabbrev || '').trim().toUpperCase();
		const name = String(fv.sales_type || '').trim();
		const lines: string[] = [
			`Abbreviation: ${typeabbrev}`,
			`Display name: ${name || '(blank)'}`,
			`Cost multiplier: ${fv.costMultiplier ?? ''}`,
			`Loyalty points: ${fv.loyaltypoints ?? ''}`,
			`Price book: ${String(fv.ispricebook) === '1' ? 'Yes' : 'No'}`,
			`Fallback price list: ${this.salesTypeFallbackLabel(String(fv.fallback || ''))}`,
		];
		if (String(fv.ispricebook) === '1') {
			lines.push(`Create new price book (seed from fallback first): ${fv.newpricebook ? 'Yes' : 'No'}`);
		}
		const n = Number(result?.updated);
		if (Number.isFinite(n) && n > 0) {
			lines.push(`Rows imported from staging table into prices: ${n}`);
		}
		if (String(fv.ispricebook) === '1' && this.uploaddata?.header) {
			const mc = this.pricebookScratchTablename ? this.mappedCount : this.matchedItems.length;
			const uc = this.pricebookScratchTablename ? this.unmappedCount : this.unmatchedItems.length;
			lines.push(`Spreadsheet preview: ${mc} matched / ${uc} unmapped (post prices with Final Post Matched).`);
		}
		return lines;
	}

	addSalesType(): void {
		if (!this.salesTypeForm.valid) {
			this.globalSearchService.showNotification('Fix the highlighted fields before saving.', 'warning', 'bottom', 'right');
			return;
		}
		this.salesTypeSaveResult = null;
		this.isSaving = true;
		this.cdr.detectChanges();

		const payload = this.buildSalesTypeSavePayload();
		this.globalsService.saveSalesType(payload).pipe(
			finalize(() => {
				this.isSaving = false;
				this.cdr.detectChanges();
			})
		).subscribe({
			next: (result: any) => {
				if (!result || result.success === false) {
					const msg = (result && (result.message || result.error)) || 'The server did not confirm this save.';
					this.salesTypeSaveResult = { ok: false, title: 'Save was not successful', lines: [msg] };
					this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
					return;
				}
				const list = result.salestypes;
				if (!Array.isArray(list)) {
					const msg = 'Save returned an unexpected response (no sales type list).';
					this.salesTypeSaveResult = { ok: false, title: 'Save response incomplete', lines: [msg] };
					this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
					return;
				}

				this.salestypes = list;
				const lines = this.buildSalesTypeSaveSummaryLines(result);
				this.salesTypeSaveResult = { ok: true, title: 'Save completed', lines };
				this.globalSearchService.showNotification(`Sales type ${String(this.salesTypeForm.get('typeabbrev')?.value || '').trim().toUpperCase()} saved.`, 'success', 'bottom', 'right');
				this.globalSearchService.reload();
			},
			error: (err: any) => {
				let msg = 'Save failed. Check your connection and try again.';
				if (err?.error) {
					if (typeof err.error === 'string') {
						const t = err.error.trim();
						if (t) {
							msg = t.length > 400 ? `${t.slice(0, 400)}…` : t;
						}
					} else if (err.error?.message) {
						msg = String(err.error.message);
					}
				} else if (err?.message) {
					msg = String(err.message);
				}
				this.salesTypeSaveResult = { ok: false, title: 'Save failed', lines: [msg] };
				this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
			},
		});
	}
	addClubDisplay() {

		this.clubForm = this.fb.group({
			id: [],
			club: ['', Validators.required],
		});
		this.modalService.open(this.addclubref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}
	editClubDisplay(club: any) {

		this.clubForm = this.fb.group({
			id: [club.id],
			club: [club.club, Validators.required],
		});
		this.modalService.open(this.addclubref, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}
	addClub() {

		this.customerService.saveClub(this.clubForm.value).subscribe(result => {
			this.clubs = result;
		});
	}
	removeClub(type: any) {
		//TODO! PREVENT THIS IF CUSTOMERS SETUP @ CLUB
		const confirm_remove = confirm('Remove club ' + type.club + '?');
		if (confirm_remove) {
			this.customerService.removeClub(type).subscribe(result => {
				this.clubs = result.clubs;
				if (result.success) {
					this.globalSearchService.showNotification('Updated', 'success', 'bottom', 'right');
				} else {
					this.globalSearchService.showNotification('Club still contains customers', 'danger', 'bottom', 'right');
				}
			});
		}
	}
	getFallbackLevel() {
		const value: string = this.salesTypeForm.get('typeabbrev').value;
		return (value != 'J' && value != 'B') ? 'B' : '';
	}


	back(): void {
		this.location.back()
	}

	ngAfterViewInit(): void {

	}


	editContactTypeDisplay(type: any) {
		this.isLoading = true;

		this.isProtectedContact = this.protectedRoles.includes(type.contact_role?.toUpperCase());

		this.contactTypeForm = this.fb.group({
			contact_type: [type.contact_type, Validators.required],
			contact_role: [{ value: type.contact_role, disabled: this.isProtectedContact }, Validators.required],
		});

		this.modalService.open(this.addcontacttyperef, {
			ariaLabelledBy: 'modal-title',
			size: 'xl'
		}).result.finally(() => {
			this.isProtectedContact = false;
		});

		this.isLoading = false;
	}


	addOrUpdateContactType() {
		if (this.contactTypeForm.valid) {
			this.globalsService.saveContactType(this.contactTypeForm.value).subscribe(result => {
				this.contacttypes = result;
				this.modalService.dismissAll();
			});
		}
	}

	removeContactType(type: any) {
		const isProtected = this.protectedRoles.includes(type.contact_role?.toUpperCase());

		if (isProtected) {
			alert('This contact role is system-defined and cannot be removed.');
			return;
		}

		const confirm_remove = confirm('Remove contact type ' + type.contact_type + '?');
		if (confirm_remove) {
			this.globalsService.removeContactType(type).subscribe(result => {
				this.contacttypes = result;
			});
		}
	}


	addContactTypeDisplay() {
		this.contactTypeForm.reset(); // clear any previous data
		this.modalService.open(this.addcontacttyperef, {
			ariaLabelledBy: 'modal-title',
			size: 'xl'
		}).result.finally(() => {
			this.isProtectedContact = false;
		});
	}

	openPaymentTermsHelp() {
		this.modalService.open(this.paymentTermsHelpRef, {
			ariaLabelledBy: 'modal-title',
			size: 'lg'
		});
	}




}